"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockPotFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dsr_",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "dsr",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "dsr_",
                type: "uint256",
            },
        ],
        name: "setDsr",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5060405161010b38038061010b8339818101604052602081101561003357600080fd5b5051610047816001600160e01b0361004d16565b50610052565b600055565b60ab806100606000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c8063487bf08214603757806362499acf14604f575b600080fd5b603d606b565b60408051918252519081900360200190f35b606960048036036020811015606357600080fd5b50356071565b005b60005481565b60005556fea265627a7a7231582022ac1a2b2fb5299160dcd3092a448ee50effbd984e6f64de1f8a1125471b817664736f6c63430005100032";
class MockPotFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(dsr_, overrides) {
        return super.deploy(dsr_, overrides || {});
    }
    getDeployTransaction(dsr_, overrides) {
        return super.getDeployTransaction(dsr_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockPotFactory = MockPotFactory;
MockPotFactory.bytecode = _bytecode;
MockPotFactory.abi = _abi;
//# sourceMappingURL=MockPotFactory.js.map